import { create } from 'apisauce'
import * as endpoints from './endpoints'
import { targetBaseUrl } from '../apiconfig';
import _ from 'lodash';

import * as actions from './../redux/actions'

// api's
import userApi from './api-user'
import productApi from './api-product'
import categoryApi from './api-category'
import messagesApi from './api-message'
import notificationsApi from './api-notification'
import subscriptionsApi from './api-subscription'
import tagsApi from './api-tag'
import statisticsApi from './api-statistics'
import merchantsApi from './api-merchant'
import domainsAdminApi from './api-domains-admin'
import storiesApi from './api-stories'

export const BASE_URL = targetBaseUrl;

const defaultApiHandler = ({ ok, problem, status, data }) => {
  if (!ok && (!data || !data.error))
    throw new Error("Unexpected error. Please try again or contact us if problem persists.")

  if (data.error) {

    console.error(data.error.message)
    console.error('Status code: ' + data.error.statusCode)

    if (data.error.validationError && data.error.validationError.length) {

      const validationErrorValues = _.flatMapDeep(data.error.validationError, (value, key) => _.map(value, (errors) => errors));
      validationErrorValues.errorKeys = data.error.validationError.reduce((accum, reducer) => {
        Object.keys(reducer).forEach(key => accum[key] = reducer[key]);
        return accum;
      }, {});

      throw validationErrorValues;
    }

    if (data.error.field) {
      const error = [data.error.message];
      error.errorKeys = {[data.error.field]: [data.error.message]};
      throw error;
    }

    throw (data.error.message || data.error || "Unexpected error. Please contact us if problem persists.").toString()

  }

  return userStatusHandler({ data })
}

const userStatusHandler = ({ data }) => {

  if (data.userStatus) {
    actions.updateUserStatus(data.userStatus)
  }
  return Promise.resolve({ data })
}

const apisauce = create({
  baseURL: BASE_URL,
  headers: { 'Content-type': 'application/json' },
  withCredentials: true
});

const apiMethods = {
  post: (url, args, config) => apisauce.post(url, args, config).then(defaultApiHandler),
  get: (url) => apisauce.get(url).then(defaultApiHandler),
  put: (url, args, config) => apisauce.put(url, args, config).then(defaultApiHandler),
  delete: (url) => apisauce.delete(url).then(defaultApiHandler)
}

export const api = {
  ...userApi(apiMethods, endpoints),
  ...productApi(apiMethods, endpoints),
  ...categoryApi(apiMethods, endpoints),
  ...messagesApi(apiMethods, endpoints),
  ...notificationsApi(apiMethods, endpoints),
  ...subscriptionsApi(apiMethods, endpoints),
  ...tagsApi(apiMethods, endpoints),
  ...statisticsApi(apiMethods, endpoints),
  ...merchantsApi(apiMethods, endpoints),
  ...domainsAdminApi(apiMethods, endpoints),
  ...storiesApi(apiMethods, endpoints)
}



// WEBPACK FOOTER //
// ./src/lib/api.js